import React from 'react'
import { useRecoilState } from 'recoil'
import { Modal } from '../../common'
import { enquiryModalDisplayState } from './enquiryModalState'
import { EnquiryForm } from '../form/EnquiryForm'

import './enquiry_modal.scss'

export const EnquiryModal = () => {
  const [value, setValue] = useRecoilState(enquiryModalDisplayState)
  const { entity, display, type } = value

  const setDisplay = (displayValue) => {
    return setValue({
      display: displayValue,
      type: type
    })
  }

  return (
    <Modal display={display} setDisplay={setDisplay}>
      <EnquiryForm product={entity} type={type} setDisplay={setDisplay} />
    </Modal>
  )
}

export default EnquiryModal